import { h, render } from 'preact';
import ProductForm from './product-form';
import ProductValueProps from './product-value-props';
import ProductDescription from './product-description';
import ProductAccordions from './product-accordions';
import ProductReviewHighlights from './product-review-highlights';
import PairItWith from './pair-it-with';
import RebuyPairItWith from './rebuy-pair-it-with';

const ProductInfo = () => {
  return (
    <div className="product-info product-info__container px-[20px] lg:px-[40px] lg:pb-5 bg-white">
      <div className="sticky-product-info">
        <ProductForm />
        <ProductDescription />
        <ProductValueProps />
        <ProductAccordions />
        <ProductReviewHighlights />
        <PairItWith />
        <RebuyPairItWith />
      </div>
    </div>
  );
};

export default ProductInfo;
